export function Empty() {
  return (
    <div className="top-[2px] m-0 min-w-[10rem] overflow-hidden rounded-md border bg-popover p-2.5 text-sm text-popover-foreground shadow-md">
      No results found.
    </div>
  );
}
